import { createFileRoute } from '@tanstack/react-router';
import { redirectToPastVideosTab } from '@/features/past-videos/redirects';

// The old address of the list (Review → Past videos, before 16 Oct 2026): Artifacts' Past videos tab, as a replace.
export const Route = createFileRoute('/_authed/review/past-videos/')({
  beforeLoad: redirectToPastVideosTab,
});
